import { axios } from '@/utils/request'

const api = {
    analysisIndexData: '/wyhadminapi/analysis/indexData',
    activityCalendar: '/wyhadminapi/analysis/activityCalendar',
    noticeData: '/wyhadminapi/analysis/noticeData',

    analysisOrderIndexData: '/wyhadminapi/analysis/analysisOrderIndexData',
}

export default api

export function analysisIndexData(parameter) {
    return axios({
        url: api.analysisIndexData,
        method: 'get',
        params: parameter
    })
}
export function activityCalendar(parameter) {
    return axios({
        url: api.activityCalendar,
        method: 'get',
        params: parameter
    })
}
export function noticeData(parameter) {
    return axios({
        url: api.noticeData,
        method: 'get',
        params: parameter
    })
}

export function analysisOrderIndexData(parameter) {
    return axios({
        url: api.analysisOrderIndexData,
        method: 'get',
        params: parameter
    })
}